import { render, staticRenderFns } from "./goBuild.vue?vue&type=template&id=42f835a8&scoped=true"
import script from "./goBuild.vue?vue&type=script&lang=js"
export * from "./goBuild.vue?vue&type=script&lang=js"
import style0 from "./goBuild.vue?vue&type=style&index=0&id=42f835a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f835a8",
  null
  
)

export default component.exports